import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idChecklist: number) => void,
    onActionDelete: (idChecklist: number | null, openState: boolean) => void,
}

export const GenerateItemChecklistEntregaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {


    return [

        {
            field: "ordem",
            filterable: false,
            headerName: "Ordem",
            minWidth: 90,
            maxWidth: 90,
            width: 90,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Item",
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-start items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: 'idItemChecklistEntrega',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 200,
            maxWidth: 200,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}